import { z } from "zod";

// t("ACTIVE")
// t("ARCHIVED")
export const genericStatusEnum = z.enum(["ACTIVE", "ARCHIVED"]);

export type GenericStatus = z.infer<typeof genericStatusEnum>;
